import styled from 'styled-components';

import { DiamondPatternBackground } from '@sorare/core/src/atoms/ui/DiamondPatternBackground';

const RadialGradient = styled.div`
  position: absolute;
  inset: 0;
  background: radial-gradient(
    ellipse at center,
    rgba(112, 41, 255, 1) 0%,
    rgba(84, 37, 194, 1) 25%,
    rgba(57, 32, 132, 1) 50%,
    rgba(43, 30, 101, 1) 62.5%,
    rgba(29, 28, 71, 1) 75%,
    rgba(15, 26, 40, 1) 87.5%,
    rgba(8, 25, 25, 1) 93.75%,
    rgba(2, 24, 9, 1) 100%
  );
`;

export const SquadBackground = () => (
  <>
    <RadialGradient />
    <DiamondPatternBackground />
  </>
);
